import React, { useState, useRef, useEffect } from 'react';
import Webcam from 'react-webcam';

import close from '../../assets/icons/close.svg';
import next from '../../assets/icons/icon.svg';
import imagePlaceholder from '../../assets/Images/image 17.png';
import addFingerprint from '../../assets/icons/FingerPrint.svg';
import { PhotoEditor } from '../PhotoEditor';
import { Postdata } from '../../API/GlobalApi';

export const GenerateIDModal = ({ isOpen, onClose, setpaymentmodal, selectedOrgDetails, capturedPhoto, setCapturedPhoto, setShowEditor, fingerprints, setFingerprints, setimgurl, setidcardmodal, idcarddata, setidcarddata }) => {
    const [showToast, setShowToast] = useState(false);
    const [toastVariant, setToastVariant] = useState('success');
    const [toastMessage, setToastMessage] = useState('');

    const webcamRef = useRef(null);
    const [showCamera, setShowCamera] = useState(false);

    const displayToast = (message, variant = 'success') => {
        setToastMessage(message);
        setToastVariant(variant);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
    };




    // const getSafe = (val) => val || "N/A";
    const getSafe = (val) =>
  val !== null && val !== undefined && val !== "" ? val : "";



    const handleFileChangeold = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setCapturedPhoto(reader.result);

            };
            reader.readAsDataURL(file);
        }

    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const result = e.target.result;
                if (result.startsWith("data:image")) {
                    setCapturedPhoto(result);

                } else {
                    displayToast("Invalid image file.", "danger");
                }
            };
            reader.readAsDataURL(file);
        }
    };


    const capturePhoto = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        setCapturedPhoto(imageSrc);
        setShowCamera(false);
        // setShowCropEditor(true);
    };

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const getMediaUrl = (path) => {
        if (!path) return imagePlaceholder;
        if (path.startsWith("http")) return path;
        return `${process.env.REACT_APP_API_BASE_URL}media/${path}`;
    };


    const prepareCapturedPhoto = async (imagePath) => {
        if (!imagePath) return null;

        const response = await fetch(imagePath, { mode: "cors" });
        const blob = await response.blob();

        return await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };



    const handleGenerate = async () => {
        // Case 1: Existing image, user did NOT reupload
        if (!capturedPhoto && idcarddata?.id_card_photo) {
            try {
                const fullUrl = `${process.env.REACT_APP_API_BASE_URL}media/${idcarddata.id_card_photo}`;
                //    const fullUrl = `http://192.168.1.44:9000/api/v1/media/${idcarddata.id_card_photo}`;
                console.log("full urle", fullUrl)
                const base64 = await prepareCapturedPhoto(fullUrl);

                setCapturedPhoto(base64);      // ✅ NOW SET
                setShowEditor(true);           // open editor
                setidcardmodal(false);         // close modal
                return;
            } catch (err) {
                displayToast("Failed to load existing image", "danger");
                return;
            }
        }

        // Case 2: New upload / camera image
        if (!capturedPhoto) {
            displayToast("Please upload or capture a photo first.", "danger");
            return;
        }

        setShowEditor(true);
        setidcardmodal(false);
    };


    return (
        <>
            <div className="modal-overlay">
                <div className="modal-content" style={{ position: 'relative', width: '50%', maxHeight: '95vh' }}>
                    <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='text-primary'>Id card registration</h2>
                        <button className="close-btn" onClick={() => { onClose(); setCapturedPhoto() }}><img src={close} alt="close" /></button>
                    </div>

                    <div className="modal-body" style={{ overflowY: 'scroll', padding: '0 10px' }}>
                        <div className="row" style={{ background: '#F9FAFC', padding: "10px" }}>
                            <h4 className='fm-pr-hd'>STUDENT'S DETAILS</h4>
                            <div className="col-md-6">

                               {(selectedOrgDetails?.first_name || selectedOrgDetails?.last_name) && ( 
                                 <> <p className='sd-p'>Name</p>
                                 <p className='n-p-t'>
                                    {getSafe(selectedOrgDetails?.first_name)}
                                      {selectedOrgDetails?.first_name && selectedOrgDetails?.last_name && " "}
                                     {getSafe(selectedOrgDetails?.last_name)}</p>
                                 </>)}
                                <p className='sd-p'>Phone</p><p className='n-p-t'>{getSafe(selectedOrgDetails?.contact_numbers?.[0]?.number)}</p>
                                <p className='sd-p'>Class</p><p className='n-p-t'>{getSafe(selectedOrgDetails?.lag?.name)}</p>
                            </div>
                            <div className="col-md-6">
                                <p className='sd-p'>Course</p><p className='n-p-t'>{getSafe(selectedOrgDetails?.lag?.academic_group?.specialization?.course_specialization)}</p>
                                <p className='sd-p'>Session</p><p className='n-p-t'>{getSafe(selectedOrgDetails?.lag?.academic_group?.name)}</p>
                            </div>
                        </div>

                        <h4 className='fm-pr-hd'>ADD STUDENT PICTURE</h4>
                        <div className="row">
                            <div className="col-md-12" style={{ display: 'flex', alignItems: 'center', gap: "20px" }}>


                                <img
                                    src={capturedPhoto || getMediaUrl(idcarddata?.id_card_photo)} alt="student" style={{ width: '100px', height: '100px' }} />
                                <button className='add-btn' onClick={() => setShowCamera(true)}>{!(capturedPhoto || selectedOrgDetails.profile_picture) ? 'Capture Image' : 'Recapture Image'}</button>
                                <div className="file-upload-container" style={{ minWidth: '0' }}>
                                    <label htmlFor="file-upload" className="upload-btn">
                                        <input type="file" id="file-upload" className="file-upload-input" onChange={handleFileChange} accept='image/*' />
                                        Upload File
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>


                    {selectedOrgDetails?.is_defaulter && (
                        <div style={{
                            background: '#FEF3F2', border: '1px solid #FDA29B',
                            borderRadius: '8px', padding: '10px 16px',
                            display: 'flex', alignItems: 'center', gap: '10px',
                            marginBottom: '12px',
                        }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="12" />
                                <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            <span style={{ color: '#D92D20', fontSize: '13px', fontWeight: 500 }}>
                                This student is marked as a defaulter. ID card generation is disabled.
                            </span>
                        </div>
                    )}

                    <div className="form-actions" style={{ background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <button
                            type="submit"
                            style={{
                                display: 'flex', alignItems: 'center', gap: '10px',
                                opacity: selectedOrgDetails?.is_defaulter ? 0.5 : 1,
                                cursor: selectedOrgDetails?.is_defaulter ? 'not-allowed' : 'pointer',
                            }}
                            onClick={selectedOrgDetails?.is_defaulter ? undefined : handleGenerate}
                            disabled={selectedOrgDetails?.is_defaulter}
                        >
                            {idcarddata?.id_card_photo ? 'Regenerate ID Card' : 'Generate ID Card'}
                            <img src={next} alt="next" />
                        </button>
                    </div>

                    {showCamera && (
                        <div className="camera-modal" style={{ backgroundColor: '#fff', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" width={300} height={300} />
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button onClick={() => setShowCamera(false)}>Cancel</button>
                                <button onClick={capturePhoto}>Take Photo</button>
                            </div>
                        </div>
                    )}


                </div>
            </div>
            {showToast && (
                <div
                    className={`custom-toast toast align-items-center text-white bg-${toastVariant} border-0 position-fixed top-0 end-0 m-3`}
                    role="alert"
                    style={{
                        display: 'block',
                        minWidth: '300px',
                        maxWidth: '400px',
                        borderRadius: '8px',
                        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                        fontSize: '15px',
                        zIndex: 9999
                    }}
                >
                    <div className="d-flex">
                        <div className="toast-body" style={{ padding: '12px 16px' }}>
                            {toastMessage}
                        </div>
                        <button
                            type="button"
                            className="btn-close btn-close-white me-2 m-auto"
                            onClick={() => setShowToast(false)}
                            aria-label="Close"
                        ></button>
                    </div>
                </div>

            )}

        </>

    );
};
